import { Stack, Typography } from "@mui/material";
import React from "react";
import { ValidationItemProps } from "../../interface/input";
import { useTheme } from "@mui/material/styles";

  
 export const ValidationItem: React.FC<ValidationItemProps> = ({ isValid, text }) => {
  const theme = useTheme();
    return (
      <Stack direction="row" spacing={1} alignItems="center" sx={{margin: '14px 0'}}>
        {!isValid ? (
          <img src="/assets/icons/dot-icon.svg" alt="" width={6} height={6} />
        ) : (
          <img src="/assets/icons/dot-color.svg" alt="" width={6} height={6} />
        )}
        <Typography sx={{
          fontSize: "10px",
          fontWeight: 500,
          fontFamily: 'DM Sans',
          lineHeight: "13px",
          color: theme.palette.text.primary,
        }}>
          {text}
        </Typography>
      </Stack>
    );
  };